import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsOnline } from '../services/globalSlice';

export default function useNetworkStatus() {
  const { isOnline } = useSelector((state) => state.global);
  const dispatch = useDispatch();

  const updateNetworkStatus = () => {
    dispatch(setIsOnline(navigator.onLine));
  };

  useEffect(() => {
    updateNetworkStatus();
  }, []);

  useEffect(() => {
    window.addEventListener('load', updateNetworkStatus);
    window.addEventListener('online', updateNetworkStatus);
    window.addEventListener('offline', updateNetworkStatus);

    return () => {
      window.removeEventListener('load', updateNetworkStatus);
      window.removeEventListener('online', updateNetworkStatus);
      window.removeEventListener('offline', updateNetworkStatus);
    };
  }, [navigator.onLine]);

  return { isOnline };
}
